import { faArrowDown, faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@nexelem/utils';
import type { SortDirection } from '@tanstack/react-table';

type SortIndicatorProps = {
  order: SortDirection | false;
};
export const SortIndicator = ({ order }: SortIndicatorProps) => (
  <FontAwesomeIcon
    className={cn('ml-4', !order && 'hidden! group-hover:block!')}
    icon={order === 'asc' ? faArrowUp : faArrowDown}
  />
);
